import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import useTheme from '@material-ui/core/styles/useTheme'
import PropTypes from 'prop-types'
import useBrand from 'components/use-brand'

const EventNotFound = ({ searchUrl }) => {
  const theme = useTheme()
  const { isJuniorLeague } = useBrand()

  const content = isJuniorLeague
    ? {
      title: 'Program not found',
      buttonLabel: 'Find Programs',
    }
    : {
      title: 'Event not found',
      buttonLabel: 'Find Events',
    }

  return (
    <Box
      px={16}
      py={24}
      style={{ background: theme.palette.grey[50] }}
      data-testid="event-not-found"
    >
      <Grid container spacing={3} justify="center">
        <Grid item sm={12} md={8}>
          <Box align="center" mb={2}>
            <Typography variant="h1" gutterBottom>
              {content.title}
            </Typography>
            <Button
              component={Link}
              color="primary"
              variant="contained"
              href={searchUrl}
            >
              {content.buttonLabel}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

EventNotFound.propTypes = {
  searchUrl: PropTypes.string,
  buttonText: PropTypes.string,
}

export default EventNotFound
